<template>
  <!-- my code -->
  <div class="wrapper-main-content">
    <!-- sidebar -->
        <div class="sidebar">
          <side-bar
            :step="step"
            :sidebarListLinks="sidebarListLinks"
          ></side-bar>
        </div>
    <!-- sidebar ends -->

    <!-- form -->
    <div class="main_content-form">
        <div class="manager-form-box p-4">
          <div class="card-body">
            <h1 class="head-title text-center font-weight-bold">
              Invite from preferred panel
            </h1>
            <p class="text-center sub-text">Select Contractor(s)</p>
            <b-form @submit.prevent="componentFormSubmitted" class="mt-5">
              <b-form-group label="What trade(s) do you require?">
                <treeselect
                  v-model="componentForm.trader_type"
                  :multiple="true"
                  :options="trader_type_option"
                  :style="{ width: '100%' }"
                  @input="filterContractors(componentForm.trader_type)"
                />
                <has-error :form="form" field="trader_type"></has-error>
              </b-form-group>
              <b-form-group>
                <b-form-input
                  style="
                    border-radius: 16px;
                    padding-top: 2.4rem;
                    padding-bottom: 2.4rem;
                  "
                  type="text"
                  v-model="search"
                  @keydown.enter.prevent
                  debounce="500"
                  placeholder="Search contractors..."
                  @keyup.enter="filterContractors(componentForm.trader_type)"
                  @keyup="handleSearchKeyup()"
                ></b-form-input>
              </b-form-group>

              <has-error
                :form="form"
                field="selected_contractor_id"
              ></has-error>

              <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-checkbox
                  class="toggler"
                  switch
                  size="lg"
                  type="text"
                  v-model="favorites_only"
                  :value="1"
                  :unchecked-value="0"
                  :aria-describedby="ariaDescribedby"
                  @change="filterContractors(componentForm.trader_type)"
                >
                  Favourites Only
                </b-form-checkbox>
              </b-form-group>
              <b-form-group
                v-slot="{ ariaDescribedby }"
                style="display: inherit"
                class="invite-form"
              >
                <b-form-checkbox-group
                  v-model="componentForm.selected_contractor_id"
                  v-for="contractor in contractors"
                  :key="'con' + contractor.id"
                  :aria-describedby="ariaDescribedby"
                  @change="selectContractors()"
                >
                  <b-form-checkbox :value="contractor.id">
                    <div>
                      <div class="comp-details">
                        <span
                          ><img src="https://via.placeholder.com/50" alt=""
                        /></span>
                        <p class="name">
                          {{ contractor.active_business.company_name }}
                        </p>
                      </div>
                    </div>
                  </b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>



              <div class="btn-actions">
                  <b-button
                    class="back-btn"
                    :disabled="form.busy"
                    type="button"
                    variant="outline-primary"
                    @click="$router.go(-1)"
                    >Back
                  </b-button>

                  <b-button
                    class="skip-btn ml-auto"
                    :disabled="form.busy"
                    type="button"
                    variant="outline-primary"
                    @click="componentFormSubmitted"
                    >Skip
                  </b-button>

                  <b-button
                    class="btn-grad btn-next"
                    :disabled="form.busy"
                    type="submit"
                    variant="primary"
                    >Next
                  </b-button>
              </div>

            </b-form>
          </div>
        </div>
    </div>
    <!-- form ends -->
  </div>
  <!-- my code ends -->

</template>

<script>
import NavBar from "../../includes/NavBar.vue";
import SideBar from "../../includes/SideBar.vue";
import FooterComponent from "../../../includes/FooterComponent.vue";
import { Treeselect, ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { HasError } from "vform";
import _ from "lodash";
import Swal from "sweetalert2";

export default {
  props: [
    "form",
    "step",
    "sidebarListLinks",
    "eventParentToChildComponentFrom",
    "selectedContractor",
    "workOrder",
  ],
  components: {
    NavBar,
    FooterComponent,
    SideBar,
    HasError,
    Treeselect,
  },
  data() {
    return {
      contractors: [],
      search: null,
      favorites_only: 0,
      componentForm: {
        selected_contractor_id: [],
        trader_type: [],
      },
      trader_type_option: [],
    };
  },
  mounted() {
    _.forEach(this.form, (value, field) => {
      if (field in this.componentForm) {
        this.componentForm[field] = value;
      }
    });

    this.debouncedFilterContractors = _.debounce(this.filterContractors, 500);


    this.filterContractors(this.componentForm.trader_type);
    this.loadCategories();

    if (
      this.$route.query.selected_contractors_id &&
      this.$route.query.selected_contractors_id.length > 0
    ) {
      this.componentForm.selected_contractor_id =
        this.$route.query.selected_contractors_id;
    }

    //Called by parent from index page
    this.eventParentToChildComponentFrom.$on(
      "event-parent-child-componentform",
      this.eventFromParentToChildComponentForm
    );
  },
  methods: {
    componentFormSubmitted() {
      this.$emit("componentFormSubmitted", this.componentForm, 4);
    },

    eventFromParentToChildComponentForm(value) {
      _.forEach(value.data, (value, field) => {
        if (field in this.componentForm) {
          this.componentForm[field] = value;
        }
      });
      this.filterContractors(this.componentForm.trader_type);
    },

    filterContractors(filter_category_id) {
      axios
        .post("api/manager/contractor/filter", {
          search: this.search,
          filter_category_id,
          filter_favorites_only: this.favorites_only,
          include_contractor_ids: this.componentForm.selected_contractor_id,
          per_page: 15,
        })
        .then((response) => {
          this.contractors = response.data.contractors;
        });
    },
    handleSearchKeyup() {
        this.debouncedFilterContractors(this.componentForm.trader_type);
    },
    loadCategories() {
      axios
        .post("api/content/getBusinessCategories", { load_children: 1 })
        .then((response) => {
          this.trader_type_option = response.data.categories.map((category) => {
            if (category.children.length > 0) {
              return {
                id: category.id,
                label: category.name,
                children: category.children.map((children) => {
                  return {
                    id: children.id,
                    label: children.name,
                  };
                }),
              };
            } else {
              return {
                id: category.id,
                label: category.name,
              };
            }
          });
        });
    },
    selectContractors() {
      if (
        this.workOrder &&
        this.componentForm.selected_contractor_id.length > 1
      ) {
        this.componentForm.selected_contractor_id.splice(1);
        Swal.fire({
          text: "Cannot select more than one contractor in work order",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
    },
  },
};
</script>


<style scoped>
  .btn-actions {
    gap: 10px;
  }
</style>
